/*
 * Green Hunters, gh-sticky-atc.js
 * Mobile Sticky-Kaufleiste (< 750px). Blendet sich beim Scrollen ein, sobald die
 * echten Kaufbuttons aus dem Viewport laufen, und wieder aus, solange sie sichtbar
 * sind (IntersectionObserver). Der Leisten-Button klickt Dawns bestehenden
 * [name="add"]-Submit; das ist derselbe Weg wie ein Tipp auf den Haupt-Button,
 * daher greift auch die gewaehlte Kaching-Staffel (Menge + Rabatt, live getestet).
 * Preis/Grundpreis folgen der gewaehlten Kaching-Stufe, ohne Kaching Dawns Preis.
 * Setzt html.gh-satc-on und --gh-satc-h, solange die Leiste sichtbar ist (das
 * Trusted-Shops-Badge rueckt dann per CSS nach oben). IIFE, defer, kein Framework.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-gh-sticky-atc]');
  if (!bar) return;

  // Dawns echter Add-to-Cart-Button (.product-form__submit, name="add").
  var realAdd = document.querySelector('.product__info-container .product-form__submit');
  if (!realAdd) return;

  var root = document.documentElement;
  var info = document.querySelector('.product__info-container');
  var stickyBtn = bar.querySelector('[data-gh-satc-add]');
  var stickyPrice = bar.querySelector('[data-gh-satc-price]');
  var stickyUnit = bar.querySelector('[data-gh-satc-unit]');

  function show() {
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
    root.style.setProperty('--gh-satc-h', bar.offsetHeight + 8 + 'px');
    root.classList.add('gh-satc-on');
  }
  function hide() {
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
    root.classList.remove('gh-satc-on');
  }

  // Leiste nur zeigen, solange die echten Kaufbuttons NICHT im Viewport sind.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          hide();
        } else {
          show();
        }
      });
    }, { threshold: 0 });
    io.observe(realAdd);
  }

  // Klick auf die Leiste loest den echten Add-to-Cart aus (Dawn AJAX + Kaching).
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (realAdd.hasAttribute('disabled')) return;
      realAdd.click();
    });
  }

  function text(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  // Gewaehlte Kaching-Stufe (falls die App fuer das Produkt rendert).
  function kachingBar() {
    var input = info && info.querySelector('.kaching-bundles__bar input:checked');
    return input ? input.closest('.kaching-bundles__bar') : null;
  }

  // Preis, Grundpreis und Verfuegbarkeit spiegeln (Variantenwechsel, Kaching-Stufe).
  function sync() {
    var kb = kachingBar();
    var priceTxt = '';
    var unitTxt = '';
    if (kb) {
      priceTxt = text(kb.querySelector('.kaching-bundles__bar-price'));
      unitTxt = text(kb.querySelector('.kaching-bundles__bar-unit-price'));
    }
    // Frisch abfragen: Dawn ersetzt den Preisblock bei Variantenwechsel.
    var priceEl = info && info.querySelector('.price');
    if (!priceTxt && priceEl) {
      var sale = priceEl.querySelector('.price__sale .price-item--sale');
      var regular = priceEl.querySelector('.price-item--regular');
      priceTxt = text(sale && sale.offsetParent !== null ? sale : regular);
      // Grundpreis aus Dawns .unit-price (ohne den visually-hidden-Label-Text).
      unitTxt = text(priceEl.querySelector('.unit-price .price-item'));
    }
    if (stickyPrice && priceTxt) stickyPrice.textContent = priceTxt;
    if (stickyUnit) stickyUnit.textContent = unitTxt;
    if (stickyBtn) {
      var soldOut = realAdd.hasAttribute('disabled');
      stickyBtn.disabled = soldOut;
      stickyBtn.textContent = soldOut ? 'Ausverkauft' : 'In den Warenkorb';
    }
  }

  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }

  sync();
  if (info) info.addEventListener('change', queueSync);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(queueSync);
    // Info-Spalte: Dawn rendert Preis/Button bei Variantenwechsel neu, Kaching
    // haengt seinen Block nachtraeglich ein und aktualisiert Preise.
    if (info) mo.observe(info, { childList: true, subtree: true, characterData: true });
    mo.observe(realAdd, { attributes: true, attributeFilter: ['disabled'] });
  }
})();
